import { BtnMenu, Menu } from "../../components/home/_menu";
import { motion } from 'framer-motion'
import ContactForm from "../../components/home/ContactForm";
import { Before, Next } from "../../components/home/Next";
import Socials from "../../components/home/Socials";

const Contacto = ({ open, setOpen }) => {

    return (
        <>

            <BtnMenu open={open} setOpen={setOpen} />


            {open && <Menu open={open} setOpen={setOpen} />}

            <motion.div
                initial={{ x: '200%' }}
                animate={{ x: 0, y: 0 }}
                exit={{ y: '150%' }}
                className="w-100 h100 d-flex justify-content-center p-md-5 mx-md-5">
                <div className="container d-flex justify-content-center mt-4 pt-5 pt-md-0 h-100">
                    <div className="col-md-9 col-12 text-start mt-2">
                        <strong className="fs-1">get in tocuh</strong>
                        <p>
                            if you want to get in touch, talk with me about a proyect colaboration please fill
                            the form below or send me an email to gabioh2012@gmail.com and lest talk.

                        </p>

                        <div className="mt-5">
                            <ContactForm />
                        </div>
                        <div className="div">
                  
                            <Socials />
                        </div>

                       
                    </div>
                </div>
                <Before name="Labs" link="/lab" />

            </motion.div>

        </>
    )
}


export default Contacto;